import React, { useEffect, useRef } from 'react';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';
import { roundFloat } from '@/utils/common';
import EcoVideo from 'eco-design/base/eco-video';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import { EU_SITE } from '@/constants';

const imgObj: Record<string, string> = {
    us: 'https://websiteoss.ecoflow.com/upload/image/1746004004503/steam_us.jpg',
    eu: 'https://websiteoss.ecoflow.com/upload/image/1745754041418/system-eu.jpg',
    de: 'https://websiteoss.ecoflow.com/upload/image/1745906890510/system-de.jpg',
    fr: 'https://websiteoss.ecoflow.com/upload/image/1745754061119/system-fr.jpg',
    it: 'https://websiteoss.ecoflow.com/upload/image/1745754071641/system-it.jpg',
    es: 'https://websiteoss.ecoflow.com/upload/image/1745754108907/system-es.jpg',
};

// const fps = 30;
const VideoAnimation: React.FC<{ pageType?: string }> = ({ pageType = 'normal' }) => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.videoanimation');
    // const videoRef = useRef<HTMLVideoElement>(null);
    // const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        // if (typeof window === 'undefined') return;
        // const video = videoRef.current;
        // const canvas = canvasRef.current;
        // if (!video) return;
        // const ctx = canvas.getContext('2d');
        // const dpr = window.devicePixelRatio || 1;
        // ctx?.scale(dpr, dpr);
        // ctx.imageSmoothingEnabled = false;
        // const sceneA = AniContainer.create({
        //     triggerElement: `.${styles.VideoAnimation}`,
        //     triggerHook: 1,
        //     offset: '100%',
        //     duration: '700%',
        //     onProcess: (percent: number) => {
        //         if (!video) return;
        //         const duration: number = video.duration;
        //         let currentTime = roundFloat(duration * percent, 2) || 0;
        //         currentTime = Math.round(currentTime * 100) / 100;
        //         video.currentTime = currentTime;
        //     },
        // });
        // let lastTime = 0;
        // const interval = 1000 / fps;
        // const drawFrame = (time: number) => {
        // if (video.paused || video.ended) return;
        // if (time - lastTime >= interval) {
        //     lastTime = time;
        // }
        // requestAnimationFrame(drawFrame);
        // };
        // video.addEventListener('loadedmetadata', () => {
        //     canvas.width = video.videoWidth;
        //     canvas.height = video.videoHeight;
        // });
        // video.addEventListener('play', () => {
        //     requestAnimationFrame(drawFrame);
        // });
        // return () => AniContainer.removeScene(sceneA);
    }, []);
    const videoanimation_desc = pageType === 'ultra' && locale === 'de' ? t('ultra_videoanimation_desc') : t('videoanimation_desc');
    return (
        <section className={styles.VideoAnimation}>
            <div className="title">{t('videoanimation_title')}</div>
            {EU_SITE.includes(locale) && <div className="desc">{videoanimation_desc}</div>}
            <div className="video-box">
                {/* <video ref={videoRef} src="https://websiteoss.ecoflow.com/upload/video/1745031425295/steamultra.mp4"></video> */}
                <EcoImg pc={imgObj[locale] || imgObj.eu} />
                {/* <canvas ref={canvasRef} id="canvas"></canvas> */}
            </div>
        </section>
    );
};

export default VideoAnimation;
